import React from "react";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import useJetSsoLink from "hooks/useJetSsoLink";
import jetLogo from "view/images/integrations/jet.png";
import useStyles from "./styles";

type SSOJetProps = {
  showId: string;
  exhibitorPairId: string;
};

/**
 * Renders on link availability rather than on the integration config, which the
 * exhibitor portal cannot read. The link comes from the shared store, so this
 * reuses the request the header's visibility check already made.
 */
function SSOJet({showId, exhibitorPairId}: SSOJetProps) {
  const classes = useStyles({headerBackground: false});
  const [link] = useJetSsoLink(showId, exhibitorPairId);

  if (!link) {
    return null;
  }

  const handleButtonClick = () => {
    window.open(link, "_blank", "noopener,noreferrer");
  };

  return (
    <div>
      <Box className={classes.tooltipAppItem}>
        <Box className={classes.tooltipItemLink} onClick={handleButtonClick}>
          <Box className={classes.imageBox}>
            <img src={jetLogo} alt="JET" />
          </Box>
          <Typography>JET</Typography>
        </Box>
      </Box>
    </div>
  );
}

export default SSOJet;
